import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { Button } from "../../UI/Button";
import { NetworkClearModal } from "../NetworkClearModal";
import { useNetworkContext } from "../../contexts/NetworkContext/context";
import { useNetwork } from "../../hooks/useNetwork";

interface IProps {
  subnetwork: number;
}

export const RequestSubnetworkClearButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const { selectedNetwork, getL2 } = useNetwork();

  const onClose = () => {
    loadNetworkInfoForNetworks([selectedNetwork.l1Id]);
  };

  const handleModalOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Button appearance="primary" onClick={handleModalOpen}>
        Request Subnetwork Clear
      </Button>
      {props.subnetwork && (
        <NetworkClearModal
          onClose={onClose}
          subnetwork={getL2(selectedNetwork.l1Id, props.subnetwork)}
        />
      )}
    </>
  );
};
